export default "__VITE_ASSET__BKBgwqmU__"